import { createFeature, createReducer, on } from '@ngrx/store';
import { AppTheme, UserPreferences } from './user-preferences.model';
import { UserPreferencesActions as Actions } from './user-preferences.actions';
import { USER_PREFERENCES as name } from '@app/core/constants/store-keys';

export const THEME_STORAGE_KEY = 'user_pref_theme';

const initialState: UserPreferences = {
  theme:
    (window.localStorage.getItem(THEME_STORAGE_KEY) as AppTheme) ??
    (window.matchMedia('(prefers-color-scheme: dark)').matches ? AppTheme.DARK : AppTheme.LIGHT)
};

const reducer = createReducer(
  initialState,
  on(Actions.toggleThemePreference, state => ({
    ...state,
    theme: state.theme === AppTheme.DARK ? AppTheme.LIGHT : AppTheme.DARK
  }))
);

export const UserPreferencesFeature = createFeature({ name, reducer });
